import React, { Component } from 'react';

class IconCloseBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                viewBox="0 0 18 18"
            >
                <circle cx="9" cy="9" r="9" fill="#26A"></circle>
                <path
                    fill="#fff"
                    d="M13.282 12.223a.745.745 0 01.218.53.748.748 0 01-1.277.53L9 10.06l-3.223 3.222a.748.748 0 11-1.06-1.059l3.224-3.222-3.223-3.222a.744.744 0 01-.218-.53.748.748 0 011.277-.53L9 7.943l3.223-3.222a.748.748 0 111.06 1.059L10.058 9l3.223 3.222z"
                ></path>
            </svg>
        );
    }
}

export default IconCloseBlue;